import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { browReport, getAdData } from './business';
import { onMittDialogReady } from '@tencent/wphk-components-dialog-manager';
import { MAINLAND_DIALOG_NAME } from '@/config/dialog';
import { ScreenDialog } from '@tencent/wphk-ui';
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';
import { biBrow, biClick } from '@tencent/fit-bi-sdk';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const adDialog = ref<InstanceType<typeof ScreenDialog> | null>(null);

const multiJumpInfo = ref();
const dpIdData = ref();

const biExt = computed(() => ({ fdpId: dpIdData.value }));

function onHide() {
  biClick('ad-dialog.close|广告弹窗关闭', biExt.value);
}

onMounted(async () => {
  const { isShowAdDialog, adInfo, dpId } = await getAdData();
  dpIdData.value = dpId;
  multiJumpInfo.value = adInfo;

  // 展示弹窗
  if (isShowAdDialog) {
    onMittDialogReady({
      dialogKey: MAINLAND_DIALOG_NAME.AD_DIALOG_NAME,
      isDialogVisible: true,
      showDialog: () => {
        adDialog.value?.show();
        dpId && browReport(dpId);
        biBrow('ad-dialog.show|广告弹窗展示', biExt.value);
      },
    });
  }
});

return { __sfc: true,adDialog, multiJumpInfo, dpIdData, biExt, onHide, ScreenDialog, MultiJumpContainer }
}

})